import { useLayoutEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { EXCLUDE_BOOTSTRAP_ROUTES } from "@/app/router/constants";

function isExcluded(pathname: string): boolean {
	return EXCLUDE_BOOTSTRAP_ROUTES.some((path) => matchPath(path, pathname));
}

function applyLegacyStylesheetState(pathname: string): void {
	const legacyLink = document.getElementById("legacy-styles") as HTMLLinkElement | null;
	if (!legacyLink) return;
	legacyLink.disabled = isExcluded(pathname);
}

// Run at module-import time so excluded routes never paint with legacy CSS on a hard load.
// Guarded so importing this module never throws in a non-browser environment
// (test runners, build-time evaluation); the browser path still runs on load.
if (typeof window !== "undefined") {
	applyLegacyStylesheetState(window.location.pathname);
}

const ManageStylesheets = () => {
	const location = useLocation();

	useLayoutEffect(() => {
		applyLegacyStylesheetState(location.pathname);
	}, [location]);

	return null;
};

export default ManageStylesheets;
